<template>
  <v-container>
    <v-breadcrumbs
      v-if="$route.path !== '/dashboard'"
      divider="/"
      class="primary--text font-weight-medium d-print-none pl-0"
      :items="breadcrumbs"
    />
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      title: 'Home',
      breadcrumbs: []
    }
  },
  watch: {
    '$route.path': function() {
      this.computeBreadcrumbs()
    }
  },
  methods: {
    computeBreadcrumbs() {
      let breadcrumbs = []
      let appends = []

      appends = this.$route.matched.map(item => {
        return {
          text: item.meta.title || '',
          exact: item.path !== this.$route.path,
          to: item.path,
          disabled: item.path === this.$route.path
        }
      })

      // Quitamos las rutas invalidas y duplicadas
      let name = ''
      let items = []
      appends.forEach(el => {
        if (el.text === 'Dashboard') {
          el.to = { name: 'Dashboard' }
        }
        if (el.text !== name && el.text.length > 0) {
          items.push(el)
        }
        name = el.text
      })

      // Deshabilitamos la ruta actual
      const item = items[items.length - 1]
      if (item) item.disabled = true

      this.breadcrumbs = breadcrumbs.concat(items)
    }
  },
  created() {
    this.computeBreadcrumbs()
  }
}
</script>
<style scoped>
.disabled {
  color: grey;
  pointer-events: none;
  text-decoration: blink;
}
.v-breadcrumbs a {
  font-size: 14px;
}
</style>
